export enum BikeCategory {
  CITYBIKE_URBANBIKE = 'Citybike, Urbanbike o.ä.',
  TREKKINGBIKE_MTB_ATB = 'Trekkingbike, MTB, ATB o.ä.',
  RENNRAD_GRAVELBIKE_CROSSBIKE_FITNESSBIKE = 'Rennrad, Gravelbike, Crossbike, Fitnessbike o.ä',
  LASTENRAD = 'Lastenrad o.ä.',
  E_BIKE_PEDELEC = 'E-Bike / Pedelec',
  OTHER = 'Sonstige'
}

export const BikeCategoryExtendedOptions = Object.entries(BikeCategory).map(([value, display]) => ({
  value: display,
  display,
}));


